exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".buttons {\n  margin-top: 20px;\n  float: right; }\n\nmd-select {\n  margin-top: 15px; }\n\ninput {\n  color: black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/shared/edit-company/edit-company.component.scss
// module id = 1282
// module chunks = 0